export const getAdminLedgerSummaryPanelStyle = (theme) => ({
    width: '350px',
    marginLeft: 'auto',
    marginRight: 'auto'
});
